module.exports = __webpack_public_path__ + "static/img/sub_page_banner_6.ddb0b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_6.jpg
// module id = sYTe
// module chunks = 0